<template>
    <favorites-state-provider #default="{ favoritesCount }">
        <span
            :class="{
                'basket-count': true,
                'basket-count--big': favoritesCount > 9,
                'basket-count--very-big': favoritesCount > 99,
            }"
        >{{favoritesCount}}</span>
    </favorites-state-provider>
</template>

<script>
import FavoritesStateProvider from './favorites-state-provider';

export default {
    name: 'favorites-count',
    components: { FavoritesStateProvider },
};
</script>
